import React from 'react';
import Switch from '@mui/material/Switch';
import { useSwitchStyles } from 'src/components/Switch/Switch.Styles';

interface ISwitch {
  name?: string;
  isChecked: boolean;
  handleChange: any;
  id?: any;
  disabled?: boolean,
  content?: boolean
}

const SwitchComponent: React.FC<ISwitch> = ({
  isChecked,
  handleChange,
  id,
  content,
  ...rest
}) => {
  const classes = useSwitchStyles(content)();

  return (
    <Switch
      {...rest}
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      id={id}
      checked={isChecked}
      onChange={handleChange}
    />
  );
};

export { SwitchComponent as Switch };
